import { render, staticRenderFns } from "./section-custom-member.vue?vue&type=template&id=68e473b3&"
import script from "./section-custom-member.vue?vue&type=script&lang=js&"
export * from "./section-custom-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports